export const getObjectToStringMatrix = (obj: any): Array<string[]> => {
  const newArray: Array<string[]> = [];
  for (let element of obj) {
    newArray.push(Object.values(element));
  }

  return newArray;
};
